import { Account } from '../../Model/Account';
import { AccountRepository, CreateAccountDTO } from '../Repositories/AccountRepository';
import { appendSuffixIfMissing, stripSuffix } from '../../../../Utils/usernameSuffix';
import { User } from '../../../User/Model/User';

export class UpdateAccountUseCase {
  constructor(private readonly repo: AccountRepository) {}

  execute(id: number, dto: Partial<CreateAccountDTO>, currentUser?: User | null): Promise<Account> {
    // 등급 수정은 어드민만 가능
    if (dto.grade != null && currentUser?.grade !== 'ADMIN') {
      throw new Error('등급 수정은 어드민만 가능합니다.');
    }

    const toSave: Partial<CreateAccountDTO> =
      dto.username ? { ...dto, username: appendSuffixIfMissing(dto.username) } : dto;
    return this.repo
      .updateAccount(id, toSave)
      .then(res => ({ ...res, username: stripSuffix(res.username) }))
      .catch(err => Promise.reject(err));
  }
}
